import { api } from "../../utils/api";

export async function getGoogleMapImage(id) {
  try {
    const response = await api.get(`map?type=google&enterprise_id=${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
